import $ from 'jquery';
import svg4everybody from 'svg4everybody';

svg4everybody();
window.$ = $;
window.jQuery = $;

require('slick-carousel');
require('perfect-scrollbar/dist/perfect-scrollbar');
require('moment');
require('daterangepicker');


// WEBPACK FOOTER //
// ./src/js/vendor.js